import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import PenggunaRHIKodeOKService from "../../../services/pengaturan/PenggunaRHIKodeOKService";
import {AUTH_TOKEN} from "../../../constants/AuthConstant";

export const getListRHIKodeOK = createAsyncThunk('penggunaRHIKodeOK/list', async (data, { rejectWithValue }) => {
    try {
        const response = await PenggunaRHIKodeOKService.list(localStorage.getItem(AUTH_TOKEN), data)
        return response
    } catch (err) {
        return rejectWithValue(err.response.data)
    }
})

export const penggunaRHIKodeOKSlice = createSlice({
    name: 'penggunaRHIKodeOK',
    initialState: {
        loading: false,
        data_rhi_kode_ok: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getListRHIKodeOK.pending, (state) => {
                state.loading = true
            })
            .addCase(getListRHIKodeOK.fulfilled, (state, action) => {
                state.loading = false
                state.data_rhi_kode_ok = action.payload.data
            })
            .addCase(getListRHIKodeOK.rejected, (state) => {
                state.loading = false
            })
    },
})

export default penggunaRHIKodeOKSlice.reducer
